import styled from "styled-components";

export const Page = styled.div`
      overflow: hidden;
      width: 100%;
      flex: 40%;
      border-radius: 8px;
      box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
      background-color: ${({ theme }) => theme.colors.secondary10};
      height: 400px;
      max-height: 400px;
      padding: 20px;
      margin-top: 30px;
      display: flex;
      flex-direction: column;
      h1 {
        margin: 0;
        padding: 0;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.secondary100};
        font-size: 18px;
        margin-bottom: 12px;
      }
      .content {
        height: 100%;
        width: 100%;
        overflow: scroll;
        overflow-x: hidden;
        margin-bottom: 12px;
      }
      p {
        align-self: center;
        cursor: pointer;
        color: ${({ theme }) => theme.colors.primary};
        font-weight: 500;
      }
`;
